module.exports = __webpack_public_path__ + "img/antinut.373348d4.png";